module.exports = __webpack_public_path__ + "static/media/icono_produccion.af50937f.svg";